import { combineReducers, configureStore } from "@reduxjs/toolkit";

import appReducer from "./reducers/App/AppSlice";
import currentUserReducer from "./reducers/CurrentUser/CurrentUserSlice";
import themeReducer from "./reducers/Theme/ThemeSlice";

const rootReducer = combineReducers({
  themeReducer,
  appReducer,
  currentUserReducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    // this is added as a workaround to solve "a non serializable value detected in state" when storing typography from theme
    // the problem is caused by the function pxtoRem
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
